import { Link } from "@mui/material";
import { useContext } from "react";
import { useRecordContext } from "react-admin";
import { useNavigate } from "react-router-dom";
import { OpenTabsContext } from "../OpenTabsContext";
import useNotify from "../unit/useNotify";

const CustomerIdLinkField = () => {
  const { successNotify, errorNotify, infoNotify } = useNotify();
  const navigate = useNavigate();
  const record = useRecordContext();
  const { openGlobalTabs } = useContext(OpenTabsContext);
  if (!record) {
    return null;
  }

  const handleClick = (id: any) => {
    if (openGlobalTabs.length >= 6) {
      if (openGlobalTabs.includes("customer-" + id + "-")) {
        navigate(`/userSummary/` + id);
      } else {
        errorNotify("Cannot open more than 6 tabs.");
        return false;
      }
    } else {
      navigate(`/userSummary/` + id);
    }
  };
  return (
    <Link
      component="span"
      onClick={() => handleClick(record.id)}
      className="numericText"
      underline="none"
      id={"customer-list-link-" + record.id}
      sx={{
        cursor: "pointer",
        textDecoration: "none",
        "&.RaLink-link": {
          color: "#1976d2",
        },
        "&:hover": {
          textDecoration: "underline",
        },
      }}
    >
      {record.id}
    </Link>
  );
};

export default CustomerIdLinkField;
